import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { MoreEventsDayDialog } from './MoreEventsDayDialog';
import type { MoreEventsDayDialogState } from './moreEventsDayDialogUtils';

type MoreEventsDialogHostProps = {
  setDialogStateRef: React.MutableRefObject<
    (state: MoreEventsDayDialogState | null) => void
  >;
  onOpenChangeRef: React.MutableRefObject<(open: boolean) => void>;
  onClose: () => void;
  onHubEventClick: (eventId: string) => void;
  onWorkoutEventClick: (
    blockId: string,
    workoutId: string,
    sourceTeamId?: string,
  ) => void;
};

/** Owns dialog state so opening/closing does not re-render the calendar grid. */
export function MoreEventsDialogHost({
  setDialogStateRef,
  onOpenChangeRef,
  onClose,
  onHubEventClick,
  onWorkoutEventClick,
}: MoreEventsDialogHostProps) {
  const [state, setState] = useState<MoreEventsDayDialogState | null>(null);

  const setStateAndNotify = useCallback(
    (next: MoreEventsDayDialogState | null) => {
      onOpenChangeRef.current(next !== null);
      setState(next);
    },
    [onOpenChangeRef],
  );

  useLayoutEffect(() => {
    setDialogStateRef.current = setStateAndNotify;
  }, [setDialogStateRef, setStateAndNotify]);

  const handleClose = useCallback(() => {
    setStateAndNotify(null);
    onClose();
  }, [onClose, setStateAndNotify]);

  return (
    <MoreEventsDayDialog
      state={state}
      onClose={handleClose}
      onHubEventClick={onHubEventClick}
      onWorkoutEventClick={onWorkoutEventClick}
    />
  );
}
